module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Princes and peoples")])]), _vm._v(" "), _c('p', {
    staticClass: "imgns",
    attrs: {
      "id": "pg24a"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "224",
      "src": "images/pg24a.jpg",
      "width": "200"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("France")])]), _vm._v(" "), _c('p', {
    staticClass: "imgns",
    attrs: {
      "id": "pg24b"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "219",
      "src": "images/pg24b.jpg",
      "width": "200"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("England")])]), _vm._v(" "), _c('p', {
    staticClass: "imgns",
    attrs: {
      "id": "pg24c"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "222",
      "src": "images/pg24c.jpg",
      "width": "198"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "imgns",
    attrs: {
      "id": "pg25a"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "239",
      "src": "images/pg25a.jpg",
      "width": "216"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Alexander VI")])]), _vm._v(" "), _c('p', {
    staticClass: "imgns",
    attrs: {
      "id": "pg25b"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "219",
      "src": "images/pg25b.jpg",
      "width": "197"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Castile")])]), _vm._v(" "), _c('p', {
    staticClass: "imgns",
    attrs: {
      "id": "pg25c"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "222",
      "src": "images/pg25c.jpg",
      "width": "200"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Moscow")])]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The majority of Europeans were the subjects of kings; most (probably four out of five) were Roman Catholics.")])]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("France.")]), _vm._v(" A hereditary monarchy. After the reign of Charles VIII (1483-98), the crown had passed to the collateral house of Orleans with Louis XI, who reigned from 1498 to 1515. Louis XI was the son of Charles of Orléans, the poet-prince, and great grandson of Charles V. His queen, Anne, was heiress of the duchy of Brittany and widow of his predecessor, Charles VIII. The country was one of the most populous in Europe, with a population of 19 million. Paris was by far the largest city, probably numbering 80,000. The kings were infrequently in residence in Paris. Louis XII preferred to hold court at the Castle of Blois in the Loire valley, his birthplace.")]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Netherlands.")]), _vm._v(" From 1482 to 1506 present-day Belgium and Holland were imperial lands of Philip the Fair of Hapsburg, who inherited them from his mother, Mary of Burgundy, together with Luxembourg and Franche-Comté. It was a prosperous land owing to the profitable trade of its cities: Ghent, the most populous, exceeding 50,000 inhabitants; Bruges, with a population of 35,000; and Antwerp, which grew to reach the size of Ghent.")]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("England.")]), _vm._v(" A hereditary monarchy. After the Battle of Bosworth Field (1485), in which Richard III was killed, the Wars of the Roses ended, and a Tudor, Henry VII, gained the throne. In 1509 he was succeeded by his son Henry VIII. The country had only 3 million inhabitants, and wealth derived mainly from sheep. London had a population of 50,000; Bristol and York had between 10,000 and 15,000.")]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Scotland")]), _vm._v(" A hereditary monarchy. The reigning monarch since 1488 was James IV Stuart, who married Margaret Tudor, daughter of King Henry VII of England. James IV met his death in 1513 at Flodden Field in battle against the English and was succeeded by his son, James V.")]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Scandinavia.")]), _vm._v(" Norway was a hereditary monarchy; Denmark and Sweden were elective monarchies. The union of these three kingdoms, dating back to the end of the 14th century, existed more in theory than reality. Sweden probably consisted of 800,000 inhabitants. The population of the other two kingdoms is unknown. Denmark was the wealthiest of the three, controlling both banks of the Kattegat. Christian I, the first of the Oldensburg monarchs, was succeeded in 1481 by his son John I, who died in 1513.")]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Germany.")]), _vm._v(" The sovereign emperor following the death of Frederick III in 1493 was his son Maximilian I of Hapsburg, who reigned until his death in 1519). The principalities (most notably the Platinate, the two Bavarias, Württemberg, Saxony, Mecklemberg, and Brandenberg), the ecclesiastical territories, counties, and cities maintained strong independence. The population totalled 20 million inhabitants. Cologne, with a population of 40,000, was the largest city, followed by Nuremberg, Augsburg, Vienna, Metz, and Strasbourg, each numbering about 20,000. Principal sources of wealth included the merchandise and manufacturing of these cities; mineral resources were also important.")]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Bohemia and Hungary.")]), _vm._v(" Two electorate monarchies of uncertain population size. Prague, the capital of Bohemia, probably numbered around 20,000 inhabitants. After George Podebrady, Ladislav II Jagiello, son of Casimir IV, king of Poland, was elected king of Bohemia in 1471. This same Ladislav was elected to the throne of Hungary after the death of Matthias Corvinus in 1490, becoming Ladislav VI of Hungary.")]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Italy.")]), _vm._v(" Four large cities (Milan, Naples, Venice, Florence) contained approximately 100,000 inhabitants; Rome and Genoa were half that number. The republic of Venice was the sole state possessing dominions outside the peninsula. Other states of importance included the duchy of Milan (occupied by France in 1500), the republic of Florence, the Papal States of the Spanish pope Alexander VI (1498-1503). The kingdoms of Naples and Sicily, Spanish possessions from the start of the 16th century, were the most populous entities. Difficult to consider as Italian was the duchy of Savoy, which joined lands on both sides of the Alps.")]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Switzerland.")]), _vm._v(" With the addition of Basel and Schaffhausen in 1501, twelve cantons formed the Swiss federation. The other cantons were Schwyz, Uri, and Unterwalden, which united in 1291; Lucerne, 1332; Zürich, 1351; Glarus and Zug, 1352; Bern, 1353; Fribourg and Solothurn, 1481. Although theoretically subjects of the empire, the three quarters of a million Swiss had, fought their way to independence.")]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Spain.")]), _vm._v(" Spain was formed by the union of several kingdoms. Castile, a hereditary kingdom, numbered 6.5 million inhabitants; Aragon, a second hereditary kingdom, had a population of 1 million. Following the marriage of Ferdinand of Aragon to Isabella of Castile in 1479, these two kingdoms were jointly governed, but were not formally united. The Moorish kingdom of Granada was conquered in 1492. Tiny Navarre, another hereditary monarchy, was joined to Castile, south of the Pyrenees, in 1512. Isabella died in 1504, and Ferdinand in 1516. The crowns the passed to their grandson Charles of Hapsburg (Charles V). Spain never again was divided.")]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Portugal.")]), _vm._v(" A hereditary monarchy of approximately 1 million inhabitants. Reigning monarchs included John II the Perfect, succeeded in 1495 by his cousin, Manuel I the Great. Overseas exploration had been underway for some time. On the other side of the Strait of Gibraltar, the Portuguese had held Ceuta since 1415 and Tangiers since 1471. Madeira was acquired in about 1420, and the Azores circa 1432. Portuguese explorers passed the Cape of Good Hope in 1488 and reached India in 1498.")]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Poland and Lithuania")]), _vm._v(" With the marriage (1386) of an Angevin (Edvige, daughter of Louis II of Hungary) to the grand prince of Lithuania (Wladislaus II Jagiello, a pagan), a union between Lithuania and Poland was formed. The Lithuanian grand duchy was hereditary, and the Polish monarchy was elective. Poland had approximately 9 million inhabitants, and Krakow was its capital.")]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Russia.")]), _vm._v(" Although estimates are uncertain, it is believed that 9 million subjects were ruled by the grand prince of Moscow. His dominions, although in expansion, were considerably smaller than contemporary European Russia. Ivan III the Great was succeeded by his son Basil (1505) and grandson Ivan IV the Terrible (1533).")]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Ottoman Empire.")]), _vm._v(" Mohammed II, conqueror of Constantinople (1453), was succeeded in turn by his son Beyazid II (1481) and grandson Selim I (1512). On the death of Mohammed II, the Ottoman dominions in Europe equalled those in Asia, and his subjects in the Balkans numbered approximately 5.5 million.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ac7106","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 78
// module chunks = 0